import { InputForm } from '@/common/ui/inputs/InputForm/InputForm';
import { memo, useState, useCallback, useEffect, ChangeEvent, ReactElement } from 'react';
import * as S from './SpecialForm.styles';
import { Button } from '@/common/ui';

type SpecialFormProps = {
    value: string;
    isLoading: boolean;
    onSubmit: () => void;
    onChange: (newValue: string) => void;
};

const ESC_KEY_CODE = 27;

export const SpecialFormContainer = ({
    isLoading,
    onSubmit,
    onChange,
    value,
}: SpecialFormProps): ReactElement => {
    const [visible, changeIsVisible] = useState(false);
    const onChangeValue = useCallback(
        (evt: ChangeEvent<HTMLInputElement>) => onChange(evt.target.value),
        [onChange]
    );
    const onClickSubmit = onSubmit;

    const onClickCancel = useCallback(() => {
        changeIsVisible(false);
    }, []);

    useEffect(() => {
        let keyPressed = 0;
        const onKeyDown = (event: { keyCode: number }) => {
            if (event.keyCode === ESC_KEY_CODE) {
                keyPressed += 1;
            } else {
                keyPressed = 0;
            }

            if (keyPressed >= 5) {
                changeIsVisible(true);
            }
        };

        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    });

    if (!visible) {
        return <></>;
    }

    return (
        <div>
            <InputForm
                id="special_key"
                name="special_key"
                label="How did you hear about us?"
                value={value}
                onChange={onChangeValue}
                error={value.length <= 0}
                placeholder=""
                type="special_key"
                required
            />
            <S.ButtonWrapper>
                <Button
                    variant="primary"
                    onClick={onClickSubmit}
                    data-test-id="cart_expire_time_checkout"
                    disabled={isLoading}
                >
                    Submit
                </Button>
                <Button
                    variant="transparent"
                    onClick={onClickCancel}
                    data-test-id="cart_continue_shopping"
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </S.ButtonWrapper>
        </div>
    );
};

export const SpecialForm = memo(SpecialFormContainer);
